import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { IEmployeeEnrollment } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";
import { useInvalidateCompanyEmployeeViews } from "./useGetCompanyEmployeeViews";
import { useInvalidateNeedsAttentionData } from "./useGetNeedsAttentionData";

type Params = {
  countryCode: number | string;
  clientInternalNumberGOS: number | string;
  payload: IEmployeeEnrollment[];
};

const createEmployeeEligibilities = async ({
  countryCode,
  clientInternalNumberGOS,
  payload,
}: Params) => {
  const response = await api.post(
    `/employeeenrollment/create/${countryCode}/${clientInternalNumberGOS}`,
    // `/employeeenrollment/${countryCode}/${clientInternalNumberGOS}/${employeeEmail}`,
    payload
  );
  return response.data as IEmployeeEnrollment;
};

export function useCreateEmployeeEligibilities(refetch = true) {
  const queryClient = useQueryClient();
  const invalidateCompanyEmployees = useInvalidateCompanyEmployeeViews();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const invalidateNeedsAttentionData = useInvalidateNeedsAttentionData();

  return useMutation(createEmployeeEligibilities, {
    mutationKey: MUTATION_KEYS.createEmployeeEligibilities,
    onSuccess: () => {
      if (refetch) {
        invalidateCompanyEmployees();

        queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.employeeDetails,
        });
        queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.companyEmployeeViews,
        });
        queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.companyPackages,
        });
        queryClient.invalidateQueries({
          queryKey: QUERY_KEYS.companyAction,
        });
      }
      invalidateNeedsAttentionData();
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
